// Phase 3.5 — Reset shop's default pricing matrix to the canonical OptiBay default.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export function useResetMatrixToDefault() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (shopId: string) => {
      // 1. Wipe the existing default-category matrix rows.
      const { error: delErr } = await (supabase as any)
        .from('shop_pricing_matrix_rows')
        .delete()
        .eq('shop_id', shopId)
        .is('category', null);
      if (delErr) throw delErr;

      // 2. Call the seed function (also logs an audit event server-side).
      const { data, error } = await (supabase as any).rpc('seed_default_pricing_matrix', {
        p_shop_id: shopId,
      });
      if (error) throw error;
      return { shopId, inserted: Number(data ?? 0) };
    },
    onSuccess: ({ shopId }) => {
      qc.invalidateQueries({ queryKey: ['shop-pricing-matrix-rows', shopId] });
      qc.invalidateQueries({ queryKey: ['parts-pricing-events', shopId] });
    },
  });
}
